<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 人口信息选择框
-->
<template>
  <div class="com-populregister-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
            clearable
          >
            <i
            class="el-icon-search el-input__icon"
            slot="suffix">
            </i>
            </el-input>
      </span>

      <populregisterRef
        ref="populregisterRef"
        :visible="isPopulregisterRefVisible"
        :custByorgId="custByorgId"
        :houseId="houseId"
        :notHistoryAndIsChargeObj="notHistoryAndIsChargeObj"
        @confirm="handlePopulregisterRefConfirm"
        :multiple="multiple"
        @cancel="handlePopulregisterRefCancel"
        append-to-body
        width="65%"
        :politicsStatus="politicsStatus"
      />
  </div>
</template>

<script>
export default {
  name: 'populregisterSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
      politicsStatus : {
          type: Boolean,
          default: () => false
      },
      custByorgId: {//客户档案新增属性：true-排除数据空校验
      type: Boolean,  
      default: () => false
      },
      houseId: {
        type: String,
        default: () => ""
      },
      notHistoryAndIsChargeObj: {//非历史且是收费对象的用户（适用于费用计算）
        type: String,
        default: () => ""
      }
  },
  data () {
    return {
        isPopulregisterRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isPopulregisterRefVisible = true;
      },
      handleClear() {},
      handlePopulregisterRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.isPopulregisterRefVisible = false;
      },
      handlePopulregisterRefCancel() {
          this.isPopulregisterRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-populregister-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/populregister/populregisterSelect.vue